<template>
    <div class="flex flex-col relative" :class="customClass">
      <select
        v-model="valueProxy"
        :class="['form-select w-full', error ? 'border-red-500' : '']"
        :required="required"
        @blur="$emit('blur')"
      >
        <option value="">{{ label }}</option>
        <option v-for="item in options" :key="item[optionValue]" :value="item[optionValue]">
          {{ item[optionLabel] }}
        </option>
      </select>
      <div v-if="error" class="form-error">{{ errorMessage }}</div>
    </div>
  </template>
  <script>
  export default {
    props: {
      value: [String, Number],
      label: String,
      options: Array,
      optionLabel: { type: String, default: 'name' },
      optionValue: { type: String, default: 'id' },
      error: Boolean,
      errorMessage: String,
      required: Boolean,
      customClass: String
    },
    computed: {
      valueProxy: {
        get() { return this.value; },
        set(val) { this.$emit('input', val); }
      }
    }
  }
  </script>
  